export function createLinks({d, tree, is_vertical,relationshipPathNodes,removedIds,spouseNodeId}) {
  const links = [];

  if (d.data.rels.spouses && d.data.rels.spouses.length > 0) handleSpouse({d,removedIds,spouseNodeId})
  handleAncestrySide({d,removedIds})
  handleProgenySide({d,removedIds})

  return links;

 function handleAncestrySide({ d, removedIds }) {
  if (!d.parents) return;
  if (Array.isArray(d.parents) && d.parents.length === 0) return;

  if (removedIds.includes(d.data.id) || d.data.data.hidden) return;

  let p = null;

  if (d.parents && d.parents.length === 1) {
    const parent = d.parents[0];

    if (removedIds.includes(parent.data.id) || parent.data.data.hidden) return;

    p = { x: parent.x, y: parent.y };

    links.push({
      d: Link(d, p),
      _d: () => {
        const _d = { x: d.x, y: d.y },
          _p = { x: d.x, y: d.y };
        return Link(_d, _p);
      },
      curve: true,
      id: linkId(d, parent),
      depth: d.depth + 1,
      is_ancestry: true,
      isRelationshipPath: checkRelationshipPath(d, parent),
    });
  } else {
    const p1 = d.parents[0],
      p2 = d.parents[1];

    if (
      removedIds.includes(p1.data.id) ||
      removedIds.includes(p2.data.id) ||
      p1.data.data.hidden ||
      p2.data.data.hidden
    )
      return;

    const mid = { x: getMid(p1, p2, "x"), y: getMid(p1, p2, "y") };

    links.push({
      d: Link(d, mid),
      _d: () => {
        const _d = { x: d.x, y: d.y },
          _p = { x: d.x, y: d.y };
        return Link(_d, _p);
      },
      isRelationshipPath:
        checkRelationshipPath(d) &&
        (checkRelationshipPath(p1) || checkRelationshipPath(p2)),
      id: linkId(d, p1, p2),
      depth: d.depth + 1,
      is_ancestry: true,
    });

    links.push({
      d: Link(mid, p1),
      _d: () => {
        const _d = { x: mid.x, y: mid.y },
          _p = { x: mid.x, y: mid.y };
        return Link(_d, _p);
      },
      isRelationshipPath: checkRelationshipPath(p1),
      id: linkId(d, p1),
      depth: d.depth + 1,
      is_ancestry: true,
    });

    links.push({
      d: Link(mid, p2),
      _d: () => {
        const _d = { x: mid.x, y: mid.y },
          _p = { x: mid.x, y: mid.y };
        return Link(_d, _p);
      },
      isRelationshipPath: checkRelationshipPath(p2),
      id: linkId(d, p2),
      depth: d.depth + 1,
      is_ancestry: true,
    });
  }
}

   function handleProgenySide({ d,removedIds }) {
    if(d.data.hasMultipleSpouses) return;
    // if (!d.children || d.children.length === 0) return;
      const hasChildren =
    (d.children && d.children.length > 0) ||
    (d.data.children && d.data.children.length > 0);

    if (!hasChildren) return;
    const children = d.children || d.data.children;
    children.forEach((temp_child) => {
      let child = tree.find(node => node.data.id == temp_child.data.id);
      if(child!=undefined && d.data.id!=child.data.id){
                  if (removedIds.includes(child.data.id) ||removedIds.includes(d.data.id)||child.data.data.hidden
                      ) return;
                if (d.data.isMultipleSpouse) {
                  // Draw direct link from this spouse to the child (skip midpoint)
                  links.push({
                    d: Link(child, d),
                    _d: () => Link({ x: _or(child, 'x'), y: _or(child, 'y') }, { x: d.x, y: d.y }),
                    curve: true,
                    id: linkId(child, d),
                    depth: d.depth + 1,
                    isRelationshipPath: checkRelationshipPath(d, child),
                  });

                  return; // Skip midpoint/multiple-parent logic entirely
                }
          else{
                        const other_parent = otherParent(child, d, tree);
                        if (other_parent && removedIds.includes(other_parent.data.id)) return;
                        let sx;
                    
                        if (!other_parent) {
                            sx=d.x;
                            links.push({
                              d: Link(child, {x: sx, y: d.y}),
                              _d: () => Link({x: sx, y: d.y}, {x: _or(child, 'x'), y: _or(child, 'y')}),
                              curve: true, id: linkId(child, d), depth: d.depth+1,isRelationshipPath: checkRelationshipPath(child, d),
                            });
                        } else 
                          {
                                  sx = other_parent.sx; // Use other parent's x position
                                  const mid = { x: getMid(d, other_parent, 'x'), y: d.y };  // Midpoint between both parents
                            
                                  // Link from child to midpoint
                                  links.push({
                                    d: Link(child, mid),
                                    _d: () => Link({ x: _or(child, 'x'), y: _or(child, 'y') }, mid),
                                    curve: true,
                                    id: linkId(child, d, other_parent),  // Unique ID based on child and both parents
                                    depth: d.depth + 1,
                                    isRelationshipPath: checkRelationshipPath(child) && (checkRelationshipPath(d) || checkRelationshipPath(other_parent)),
                                  });
                            
                                  // Link from midpoint to parent (d)
                                  links.push({
                                    d: Link(mid, d),
                                    _d: () => Link(mid, { x: d.x, y: d.y }),
                                    curve: true,
                                    id: linkId(child, d),  // Unique ID based on child and parent (d)
                                    depth: d.depth + 1,
                                    isRelationshipPath: checkRelationshipPath(d),
                                  });
                            
                                  // Link from midpoint to other parent
                                  links.push({
                                    d: Link(mid, other_parent),
                                    _d: () => Link(mid, { x: other_parent.x, y: other_parent.y }),
                                    curve: true,
                                    id: linkId(child, other_parent),  // Unique ID based on child and other parent
                                    depth: d.depth + 1,
                                    isRelationshipPath: checkRelationshipPath(other_parent),
                                  });
                           }
            }
    }
    });
  }
  
//OLD METHOD FOR REVERTING
  // function handleProgenySide({d}) {
  //   console.log("from handleProgenySide")
  //   if (!d.children || d.children.length === 0) return
  //   // console.log(d)
  //   d.children.forEach((child, i) => {
  //           console.log("before making decision...")
  //           console.log(d);
  //           console.log(child);
  //           if(child.data.id!=d.data.id){
  //               const other_parent = otherParent(child, d, tree);
  //               console.log("other parent...");
  //               console.log(other_parent);
  //               let sx;
  //               if(!other_parent){
                  // sx=d.x;
                  // links.push({
                  //   d: Link(child, {x: sx, y: d.y}),
                  //   _d: () => Link({x: sx, y: d.y}, {x: _or(child, 'x'), y: _or(child, 'y')}),
                  //   curve: true, id: linkId(child, d), depth: d.depth+1,isRelationshipPath: checkRelationshipPath(child, d),
                  // });
  //               }
  //               else{
  //                 // console.log("Inside else...")
  //                 // console.log(child)
  //                 sx = other_parent.sx;
  //                 links.push({
  //                   d: Link(child, {x: sx, y: d.y}),
  //                   _d: () => Link({x: sx, y: d.y}, {x: _or(child, 'x'), y: _or(child, 'y')}),
  //                   curve: true, id: linkId(child, d, other_parent), depth: d.depth+1,isRelationshipPath: checkRelationshipPath(child, d, other_parent),
  //                 })
  //               }
  //         }
  //   })
  // }


  function handleSpouse({ d, removedIds = [],spouseNodeId }) {
  d.data.rels.spouses.forEach(sp_id => {
    const spouse = tree.find(d0 => d0.data.id === sp_id);

    // Skip if spouse not found OR already has spouse link
    if (!spouse || d.spouse) return;

    // 🔍 Skip if either spouse is hidden or removed
    if (
      removedIds.includes(d.data.id) ||
      removedIds.includes(spouse.data.id) ||
      d.data.data.hidden ||
      spouse.data.data.hidden
    ) {
      return;
    }

    // Add spouse link
    links.push({
      d: [[d.x, d.y], [spouse.x, spouse.y]],
      _d: () => [
        d.is_ancestry
          ? [_or(d, "x") - 0.0001, _or(d, "y")]
          : [d.x, d.y], // add -.0001 if same x
        spouse.is_ancestry
          ? [_or(spouse, "x", true), _or(spouse, "y")]
          : [d.x - 0.0001, d.y],
      ],
      curve: false,
      id: [d.data.id, spouse.data.id].join(", "),
      depth: d.depth,
      spouse: true,
      is_ancestry: spouse.is_ancestry,
      isRelationshipPath: checkRelationshipPath(d, spouse),
      isSpouse:spouseNodeId.includes(sp_id)? true : false
    });
  });
}

  function checkRelationshipPath(...nodes) {
    // console.log("inside checkRelationshipPath")
    // nodes.forEach(node => {
    //   console.log(node.data.data.first_name);
    // });
        if(relationshipPathNodes){
      const result=nodes.every(node => relationshipPathNodes.includes(node.data.id))
      // console.log(result)
      return result
    } ;

  }
  ///
  function getMid(d1, d2, side, is_) {
    if (is_) return _or(d1, side) - (_or(d1, side) - _or(d2, side))/2
    else return d1[side] - (d1[side] - d2[side])/2
  }

  function _or(d, k) {
   return d.hasOwnProperty('_'+k) ? d['_'+k] : d[k]
  }

  function Link(d, p) {
    // const hy = (d.y + (p.y - d.y) / 2)
    let hy;
    if(d.sibling_y) {
      hy = (d.sibling_y + (p.y - d.sibling_y) / 2)
    }
    else {
      let temp_y = d.originalPos ? d.originalPos.y : d.y;
      hy = (temp_y + (p.y - temp_y) / 2)
    }
    return [
      [d.x, d.y],
      [d.x, hy],
      [d.x, hy],
      [p.x, hy],
      [p.x, hy],
      [p.x, p.y],
    ]
  }

  function linkId(...args) {
    return args.map(d => d.data.id).sort().join(", ")  // make unique id
  }

  function otherParent(d, p1, data) {
    return data.find(d0 => (d0.data.id !== p1.data.id) && ((d0.data.id === d.data.rels.mother) || (d0.data.id === d.data.rels.father)))
  }
}




